import gql from "graphql-tag";

export const logisticsActivityLogFragment = gql`
  fragment LogisticsActivityLogFragment on LogisticsActivityLog {
    id
    createdAt
    newValues
    action
    type
    format
    doer {
      email
    }
    malls {
      id
      name
    }
  }
`;
